import { useEffect, useRef } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function ModalVideo({ config, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!config) {
      if (videoRef.current) {
        videoRef.current.pause()
        videoRef.current.src = ""
      }
      return
    }

    setTimeout(() => {
      videoRef.current.src = config.videoUrl
    }, 500)

    // if (Hls.isSupported()) {
    //   const hls = new Hls()
    //   hls.loadSource(config.videoUrl)
    //   hls.attachMedia(videoRef.current)
    // } else {
  }, [config])

  const handleError = () => {
    //setError("Não foi possível carregar o vídeo. Verifique a URL e tente novamente.");
    onClose && onClose();
  };

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalHeader toggle={onClose}>
        {config?.descricao || 'Visualização da Câmera'}
      </ModalHeader>
      <ModalBody>
        <video
          ref={videoRef}
          controls
          autoPlay
          onError={handleError}
          style={{ width: '100%' }}
        />
      </ModalBody>
    </Modal>
  )
}